import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { take } from 'rxjs/operators'

@Component({
  selector: 'app-confirm-reflect-dialog',
  templateUrl: './confirm-reflect-dialog.component.html',
  styleUrls: ['./confirm-reflect-dialog.component.scss']
})
export class ConfirmReflectDialogComponent implements AfterViewInit {

  @ViewChild('applyJustThisOneButton', { read: ElementRef }) applyJustThisOneButton: ElementRef<HTMLButtonElement>

  onClose
  onApplyAll
  onApplyJustThisOne
  cancelText: string
  applyJustThisOneText: string
  applyAllText: string
  title: string
  confirmMessage: string

  focusApplyJustThisOne: boolean = false

  private previouslyFocusedElement: HTMLElement | null = null


  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<ConfirmReflectDialogComponent>) {
    // Capture focus before the dialog takes it, so we can restore on close.
    this.previouslyFocusedElement = (document.activeElement as HTMLElement) || null

    if (data) {
      this.onClose = data.onClose || this.dialogRef.close
      this.onApplyAll = data.onApplyAll
      this.onApplyJustThisOne = data.onApplyJustThisOne
      this.cancelText = data.cancelText
      this.applyAllText = data.applyAllText
      this.applyJustThisOneText = data.applyJustThisOneText
      this.title = data.title
      this.confirmMessage = data.message
      this.focusApplyJustThisOne = !!data.focusApplyJustThisOne
    }

    const closed$ = (this.dialogRef as any)?.afterClosed?.()
    if (closed$) {
      closed$.pipe(take(1)).subscribe(() => {
      const el = this.previouslyFocusedElement
      setTimeout(() => {
        // Only restore if the element still exists and is focusable.
        if (el && typeof (el as any).focus === 'function' && document.contains(el)) {
          el.focus()
        }
      }, 0)
      })
    }
  }

  ngAfterViewInit(): void {
    if (!this.focusApplyJustThisOne) {
      return
    }

    const opened$ = (this.dialogRef as any)?.afterOpened?.()
    if (!opened$) {
      return
    }

    opened$.pipe(take(1)).subscribe(() => {
      setTimeout(() => {
        this.applyJustThisOneButton?.nativeElement?.focus()
      }, 0)
    })
  }

  handleCancel() {
    this.onClose()
  }

  handleApplyAll() {
    this.onApplyAll()
  }

  handleApplyJustThisOne() {
    this.onApplyJustThisOne()
  }
}
